import { setCookie } from '../../hooks/useCookie';
import { setLocalStorageWithPrefix } from '../../hooks/useLocalStorage';

export const handleYes = async (openAccountCheck, setLoginModal, setLoader) => {
  openAccountCheck.disable();
  setLoginModal(true);
  setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', true);
  setLoader(false);
};

export const handleNo = async (e, openAccountCheck, dispatch, onPageLoad) => {
  e.stopPropagation();
  dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: true });
  setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', false);
  setCookie('ION', 'cart_Type', 'NEW_ACQUISITION');
  onPageLoad();
  openAccountCheck.disable();
};
